import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment.development";
import { SolicitudCancelarRequest } from "../interfaces/solicitud-cancelar.interface";

const apiVucUrl = environment.apiVucUrl;
@Injectable({
    providedIn: 'root'
})

export class SolicitudCancelarService {

    constructor(private http: HttpClient) {}

    cancelarSolicitud(data: SolicitudCancelarRequest[]): Observable<any>{
        return this.http.post(`${apiVucUrl}api/v1.0/solicitud/cancelar`, data);
    }
}